<script setup lang="ts">
import { ExternalLink } from 'lucide-vue-next';

withDefaults(
  defineProps<{
    linkable?: boolean;
  }>(),
  {
    linkable: true,
  },
);
</script>

<template>
  <div class="flex h-fit flex-col gap-1">
    <span class="flex items-center gap-2">
      <span
        class="flex gap-1"
        aria-hidden="true"
      >
        <UiCustomStar
          v-for="index in 4"
          :key="index"
        />
        <UiCustomStar :fill="0.75" />
      </span>
      <span class="text-sm font-medium text-text-primary-900">4,7/5</span>
    </span>
    <span class="flex items-center gap-1 text-sm font-normal text-text-secondary-600">
      <template v-if="linkable === false">
        {{ $t('components.home.ekomiReviews.reviewsLinkText') }}
      </template>
      <template v-else>
        <NuxtLink
          to="https://www.ekomi.fr/avis-clients-option-way.html"
          target="_blank"
          :aria-label="$t('components.home.ekomiReviews.reviewsLinkAriaLabel')"
          class="inline-flex items-center gap-1 hover:text-text-accent-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-primary-700"
        >
          {{ $t('components.home.ekomiReviews.reviewsLinkText') }}
          <ExternalLink
            class="size-3.5 shrink-0"
            aria-hidden="true"
          />
        </NuxtLink>
      </template>
    </span>
  </div>
</template>
